<div class="level">
  <div *ngFor="let item of itemsLevel" [ngClass]="['level-items', item.status]">
    <app-text
      *ngIf="item.label === active"
      [text]="item.label"
      [fontSize]="10"
      colorClass="color-gray-300"
    >
    </app-text>
  </div>
</div>
